export const FIELD_MAX_LENGTHS = {
  PROPERTY_NAME: 40,
  PROPERTY_ADDRESS: 80,
  BUILDING_NAME: 40,
  UNIT_NUMBER: 10,
  TENANT_NAME: 40,
  TENANT_CONTACT: 40,
  FIRST_NAME: 20,
  LAST_NAME: 20,
  EMAIL: 40,
  DEV_EUI: 16,
} as const;

export const DEV_EUI_PATTERN = '[0-9A-Fa-f]{16}';
export const DEV_EUI_REGEX = /^[0-9A-F]{16}$/;
export const PASSWORD_MIN_LENGTH = 12;

export const JOIN_EUI_REGEX = /^[0-9A-F]{16}$/;
export const APP_KEY_REGEX = /^[0-9A-F]{32}$/;
